const devSidebarLinks = [
  {
    id: 0,
    title: 'Intro',
    url: '/developers/documentation/',
  },
  {
    id: 1,
    title: 'Get Started',
    url: '/developers/documentation/getting-started/',
    items: [
      {
        id: 0,
        title: 'Exploring the API',
        url: '/developers/documentation/getting-started#exploring-the-api',
      },
      {
        id: 1,
        title: 'Authentication',
        url: '/developers/documentation/getting-started#authentication',
      },
      {
        id: 2,
        title: 'Making calls from your code',
        url:
          '/developers/documentation/getting-started#making-calls-from-your-code',
      },
      {
        id: 3,
        title: 'Introspecting the schema',
        url:
          '/developers/documentation/getting-started#introspecting-the-schema',
      },
    ],
  },
  {
    id: 2,
    title: 'Authentication',
    url: '/developers/documentation/authentication/',
    items: [
      {
        id: 0,
        title: 'Personal access tokens',
        url: '/developers/documentation/authentication#personal-access-tokens',
      },
      {
        id: 1,
        title: 'OAuth 2',
        url: '/developers/documentation/authentication#oauth-2',
      },
      {
        id: 2,
        title: 'OAuth 2: Implementing PKCE',
        url: '/developers/documentation/authentication/pkce',
      },
      {
        id: 3,
        title: 'Available token scopes',
        url: '/developers/documentation/authentication#available-token-scopes',
      },
    ],
  },
  {
    id: 3,
    title: 'Tutorials',
    url: '/developers/documentation/tutorials/',
    type: 'dropdown',
    items: [
      {
        id: 0,
        title: "Get a user's identity",
        url: '/developers/documentation/tutorials#get-a-users-identity',
      },
      {
        id: 1,
        title: "Get a user's projects",
        url: '/developers/documentation/tutorials#get-a-users-projects',
      },
      {
        id: 2,
        title: 'Embed a Marvel prototype',
        url: '/developers/documentation/tutorials#embed-a-marvel-prototype',
      },
      {
        id: 3,
        title: 'Create a project',
        url: '/developers/documentation/tutorials#create-a-project',
      },
      {
        id: 4,
        title: "Get a project's screens",
        url: '/developers/documentation/tutorials#get-a-projects-screens',
      },
      {
        id: 5,
        title: 'Add screens to a project',
        url: '/developers/documentation/tutorials#add-designs-to-a-project',
      },
      {
        id: 6,
        title: 'Arrange screens',
        url: '/developers/documentation/tutorials#arrange-screens',
      },
      {
        id: 7,
        title: 'Commenting',
        url: '/developers/documentation/tutorials/commenting',
      },
    ],
  },
  {
    id: 4,
    title: 'Image Uploads',
    url: '/developers/documentation/uploads/',
    items: [
      {
        id: 0,
        title: 'Authentication',
        url: '/developers/documentation/uploads#authentication',
      },
      {
        id: 1,
        title: 'Request',
        url: '/developers/documentation/uploads#request',
      },
      {
        id: 2,
        title: 'Response',
        url: '/developers/documentation/uploads#response',
      },
      {
        id: 3,
        title: 'Supported file types',
        url: '/developers/documentation/uploads#supported-file-types',
      },
    ],
  },
  {
    id: 5,
    title: 'Arrange Screens',
    url: '/developers/documentation/arrange-screens/',
    items: [
      {
        id: 1,
        title: 'Create a section',
        url: '/developers/documentation/sections#create-a-section',
      },
      {
        id: 2,
        title: 'Add screens to a section',
        url: '/developers/documentation/sections#add-screens-to-a-section',
      },
      {
        id: 3,
        title: 'Arrange screens',
        url: '/developers/documentation/sections#arrange-screens',
      },
      {
        id: 4,
        title: 'Ungroup screens from a section',
        url:
          '/developers/documentation/sections#ungroup-screens-from-a-section',
      },
      {
        id: 5,
        title: 'Ordering sections',
        url: '/developers/documentation/sections#ordering-sections',
      },
    ],
  },
  {
    id: 6,
    title: 'Embeds',
    url: '/developers/documentation/embeds/',
    items: [
      {
        id: 0,
        title: 'On websites',
        url: '/developers/documentation/embeds#embedding-on-your-website',
      },
      {
        id: 1,
        title: 'On other platforms',
        url: '/developers/documentation/embeds#embedding-on-other-platforms',
      },
      {
        id: 2,
        title: 'For developers',
        url: '/developers/documentation/embeds#embedding-for-developers',
      },
    ],
  },
  {
    id: 7,
    title: 'Pagination',
    url: '/developers/documentation/pagination/',
  },
  {
    id: 8,
    title: 'Terms of Use',
    url: '/developers/documentation/terms/',
  },
  {
    id: 9,
    title: 'Contact Us',
    url: '/developers/documentation/contact/',
  },
];

export default devSidebarLinks;



// WEBPACK FOOTER //
// ./src/configs/devSidebarLinks.js